/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import { useNavigate } from "react-router";
import { modalview } from "@/src/services/useTracker";
import ApiClient from "@/src/services/apiClient";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { Box, Typography } from "@mui/material";

export default function EmailVerificationModal() {
  const navigate = useNavigate();
  const { customer, setRefetchInterval } = useCustomer();

  useEffect(() => {
    setRefetchInterval(!customer?.verification ? 5000 : false);
  }, [customer?.verification]);

  if (!customer) {
    return (
      <DialogModal open={true} title={"Technischer Fehler"}>
        <Typography>
          Leider ist ein technischer Fehler aufgetreten. Bitte melden Sie sich per E-Mail an service@legalbird.de, damit wir Ihnen zeitnah weiterhelfen können.
        </Typography>
      </DialogModal>
    );
  }

  if (!!customer.verification) {
    return null;
  }

  const resendEmail = async () => {
    await ApiClient.post("/resend_welcome_email");
    navigate("/servicewelt");
  };

  if (customer.verification === null) {
    modalview("Email Verification Modal");
  }

  return (
    <DialogModal
      open={true}
      title={"E-Mail-Adresse bestätigen"}
      actions={
        <Button fullWidth={true} variant={"contained"} onClick={resendEmail}>
          Erneut zuschicken
        </Button>
      }
    >
      <Typography sx={{ marginBottom: "16px" }}>
        Bitte bestätigen Sie Ihre E-Mail-Adresse. Klicken Sie hierzu einfach auf den Link in der E-Mail, die Sie von uns auf{" "}
        <Box component={"strong"} sx={{ wordBreak: "break-all" }}>
          {customer.email}
        </Box>{" "}
        erhalten haben.
      </Typography>
      <Typography>Sie finden die E-Mail nicht? Dann prüfen Sie kurz Ihren SPAM-Ordner, oder schicken Sie sich die E-Mail erneut zu.</Typography>
    </DialogModal>
  );
}
